var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"canvas"}}),_c('div',{staticClass:"mark"},[_c('div',{staticClass:"list"},_vm._l((500),function(i){return _c('div',{key:i,staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.name || "聚瑞云控"))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }